import { prepareXVerdictOnboarding } from '@/services/xverdict_entity_config_service';

function positive_number(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

function text(value = '') {
  return String(value || '').trim();
}

function has_registration_summary(manual_case = {}) {
  return Boolean(text(manual_case?.description) || text(manual_case?.requester));
}

function contact_is_invalid_email(contact = '') {
  const value = text(contact);
  return value.includes('@') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

function unique_form_ids(forms = []) {
  return [...new Set(
    (Array.isArray(forms) ? forms : [])
      .map((form) => positive_number(form?.form_id || form?.id))
      .filter(Boolean)
  )];
}

export async function resolve_manual_case_form_ids({
  entity_type_id,
  project_id = null,
  fallback_form_ids = [],
} = {}) {
  const fallback = unique_form_ids(
    (Array.isArray(fallback_form_ids) ? fallback_form_ids : []).map((form_id) => ({ form_id }))
  );

  try {
    const response = await prepareXVerdictOnboarding({
      entity_type_id: positive_number(entity_type_id),
      project_id: positive_number(project_id),
    });
    const blueprint = response?.data || response || {};
    return unique_form_ids(blueprint.forms).length
      ? unique_form_ids(blueprint.forms)
      : fallback;
  } catch {
    return fallback;
  }
}

export function created_manual_case(create_data = {}, entity_type_id = null) {
  const data = create_data?.data || create_data || {};
  const application_id = positive_number(data.application_id);
  const entity_profile_id = positive_number(data.entity_profile_id);
  const case_code = String(
    data.reference_number
    || data.case_code
    || (application_id ? `C-${application_id}` : '')
  ).trim();

  return {
    application_id,
    entity_profile_id,
    entity_type_id: positive_number(entity_type_id),
    case_code,
  };
}

export function validate_manual_case_registration(manual_case = {}, selected_case_type = {}) {
  if (!positive_number(selected_case_type?.id || manual_case?.case_type)) {
    return 'Select a case type before registering the case.';
  }

  if (!has_registration_summary(manual_case)) {
    return 'Enter a requester or short description before registering the case.';
  }

  if (contact_is_invalid_email(manual_case?.contact)) {
    return 'Enter a valid contact email address.';
  }

  return '';
}
